(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collections-nav')) {
    customElements.define('collections-nav', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        if (!details || !summary) return;
        const sync = () => summary.setAttribute('aria-expanded', String(details.open));
        sync();
        details.addEventListener('toggle', sync, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            details.open = false;
            sync();
            summary.focus();
          }
        }, options);
        document.addEventListener('click', (event) => {
          if (details.open && !details.contains(event.target)) {
            details.open = false;
            sync();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) {
            details.open = false;
            sync();
          }
        }, options);
      }
      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
